/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import BarChartConfiguration from './bar-chart-configuration';
import TableConfiguration from './table-configuration';
import ColumnChartConfiguration from './column-chart-configuration';
import AreaChartConfiguration from './area-chart-configuration';

import PieChartConfiguration from './pie-chart-configuration';
import LineChartConfiguration from './line-chart-configuration';
import NumberConfiguration from './number-configuration';


const ChartConfiguration = ({ chartType }) => {
	switch (chartType) {
		case 'AREA':
			return <AreaChartConfiguration />;
		case 'TABLE':
			return <TableConfiguration />;
		case 'COLUMN':
			return <ColumnChartConfiguration />;
		case 'BAR':
			return <BarChartConfiguration />;
		case 'LINE':
			return <LineChartConfiguration />;
		case 'PIE':
			return <PieChartConfiguration />;
		case 'NUMBER':
			return <NumberConfiguration />;
		default:
			return null;
	}
};

export default ChartConfiguration;
